import Cookies from 'js-cookie';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';

export const hasAuthCookie = () => !!Cookies.get('cw_d_session_info');

const getSSOAccountPath = ({ ssoAccountId, user }) => {
  const { accounts = [], account_id: accountId = null } = user || {};
  const ssoAccount = accounts.find(account => account.id === Number(ssoAccountId));
  if (ssoAccount) return `accounts/${ssoAccountId}`;
  if (accounts.length) return `accounts/${accountId || accounts[0].id}`;
  return '';
};

const capitalize = str =>
  str
    .split(/[._-]+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const getCredentialsFromEmail = email => {
  const [localPart, domain] = email.split('@');
  const namePart = localPart.split('+')[0];
  return {
    fullName: capitalize(namePart),
    accountName: capitalize(domain.split('.')[0]),
  };
};

export const getLoginRedirectURL = ({ ssoAccountId, ssoConversationId, user }) => {
  const accountPath = getSSOAccountPath({ ssoAccountId, user });
  if (accountPath) {
    // Explicit conversation links must keep opening the requested conversation.
    if (ssoConversationId) {
      return frontendURL(`${accountPath}/conversations/${ssoConversationId}`);
    }
    return frontendURL(`${accountPath}/inicio`);
  }
  return DEFAULT_REDIRECT_URL;
};
